import { render, staticRenderFns } from "./cadcobrancasbancarias.vue?vue&type=template&id=2af616ea&"
import script from "./cadcobrancasbancarias.vue?vue&type=script&lang=js&"
export * from "./cadcobrancasbancarias.vue?vue&type=script&lang=js&"
import style0 from "./cadcobrancasbancarias.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports